module.exports = __webpack_public_path__ + "img/puzzle_8.e1a9cd5a.png";